import { render, staticRenderFns } from "./orderStatementHeaderPrint.vue?vue&type=template&id=60eceb3b&"
import script from "./orderStatementHeaderPrint.vue?vue&type=script&lang=ts&"
export * from "./orderStatementHeaderPrint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports